import { rootState } from '@core-interface'

export const getResultList = (state:rootState) => state?.resultReducer?.list;  
export const getLoadingStatus = (state:rootState) => state?.resultReducer?.loading;   
export const getBookNowPopupStatus = (state:rootState) => state?.resultReducer?.booknowPopup;   
export const getTotal = (state:rootState) => state?.resultReducer?.total;   